import {defineStore} from "pinia";
import io from "socket.io-client";
import EventEmitter from "events";

let socket = null;
export const socketStore = defineStore("socket", {
    state: () => ({
        host: null,
        port: null,
        isConnected: false
    }),

    actions: {
        init(host, port) {
            this.host = host;
            this.port = port;
            this.emitter = new EventEmitter();
        },

        connect() {
            if (socket === null) {
                const options = {
                    rejectUnauthorized: false,
                    transports: ["websocket"],
                    upgrade: false,
                    reconnection: true,
                    reconnectionAttempts: Infinity,
                    timeout: 20000,
                    pingInterval: 25000,
                    pingTimeout: 60000 // Increase from default 20s to 60s
                };
                socket = io(this.host + ":" + this.port, options);
                socket.on("connect", () => this.onConnect());
                socket.on("disconnect", () => this.onDisconnect());
            }
        },

        onConnect() {
            console.log("connected socket in store");
            this.emit("APP_CONNECTED"); // emit to socket service
            this.emitter.emit("APP_CONNECTED"); // emit to measurement service
            this.isConnected = true;
        },

        onDisconnect() {
            this.emitter.emit("APP_DISCONNECTED"); // emit to measurement service
            this.isConnected = false;
        },

        onSocketConnected(callback) {
            this.emitter.on("APP_CONNECTED", callback);
        },

        onSocketDisconnected(callback) {
            this.emitter.on("APP_DISCONNECTED", callback);
        },

        on(message, callback) {
            if (socket !== null) {
                socket.on(message, callback);
            }
        },

        off(message, callback) {
            if (socket !== null) {
                socket.off(message, callback);
            }
        },

        emit(message, data) {
            if (socket !== null) {
                socket.emit(message, data);
            }
        },

        removeAllListeners(message) {
            if (socket !== null) {
                socket.removeAllListeners(message);
            }
        },

        close() {
            if (socket !== null) {
                socket.close();
                socket.removeAllListeners();
                socket = null;
            }
        }
    }
});